import { cn } from "@/lib/cn";

export interface ChartPanelProps {
  /** Eyebrow title (uppercase, mono) */
  title: string;
  /** Optional subtitle below title */
  subtitle?: string;
  /** Chart content */
  children: React.ReactNode;
  /** Optional className for outer container */
  className?: string;
}

/**
 * Shared panel wrapper for all chart visualizations.
 * Provides consistent SLATE styling with title, subtitle, and content area.
 */
export function ChartPanel({ title, subtitle, children, className }: ChartPanelProps) {
  return (
    <div
      className={cn(
        "rounded-[14px] border border-line bg-surface p-5",
        "shadow-[0_1px_2px_rgba(11,20,38,0.04),0_12px_30px_rgba(11,20,38,0.06)]",
        className,
      )}
    >
      <div className="mb-3 space-y-1">
        <h3 className="font-mono text-[11px] font-semibold uppercase tracking-[0.12em] text-navy-300">
          {title}
        </h3>
        {subtitle && <p className="text-xs text-muted">{subtitle}</p>}
      </div>
      <div className="min-h-[200px]">{children}</div>
    </div>
  );
}
